import React, { useEffect } from 'react';
import InfoDialog from '../../../../../components/shared/InfoDialog';
import Card from '../../../../../components/material-ui/adaptive/Card';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import { List, ListItem, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CasinoUsedCollection({
  open,
  onClose,
  casinos,
  collectionList,
  updateCasinos,
  modalCasinoInfoId
}) {
  const { t } = useTranslation();

  const casino = casinos.find((curCasino) => curCasino.id == modalCasinoInfoId);

  const collections = casino?.collections || [];
  const isCollection = Object.keys(collections).length;

  useEffect(() => {
    if (!open) return;
    updateCasinos();
  }, [open]);

  const collectionsList = Object.keys(collections);
  const isManyCollection = collectionsList.length > 1;

  if (!casino) return <></>;

  return (
    <InfoDialog open={open} onClose={onClose}>
      <Card>
        <ShowContainer
          condition={isCollection}
          plug={
            <Typography variant="h6">
              {t('There are no collections associated with the casino', {
                casino: `"${casino.casinoName}"`
              })}
            </Typography>
          }>
          <Typography variant="h6">
            {t('The casino uses these collections', { casino: casino.casinoName })}
          </Typography>
          <Stack mt={2}>
            <List>
              {Object.keys(collections).map((collectId) => {
                const curCollection = collections[collectId];

                return (
                  <ListItem key={collectId}>
                    <Stack>
                      <Typography>{curCollection.name}</Typography>
                      <Typography color="textSecondary" fontSize={12}>
                        {!curCollection.currencyList.length
                          ? t(isManyCollection ? 'Any other currency' : 'Any currency')
                          : curCollection.currencyList.join(',')}
                      </Typography>
                    </Stack>
                  </ListItem>
                );
              })}
            </List>
          </Stack>
        </ShowContainer>
      </Card>
    </InfoDialog>
  );
}
